import { render } from "./FormLegend.vue?vue&type=template&id=67b92ae3&scoped=true"
import script from "./FormLegend.vue?vue&type=script&lang=js"
export * from "./FormLegend.vue?vue&type=script&lang=js"

import "./FormLegend.vue?vue&type=style&index=0&id=67b92ae3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b92ae3"]])

export default __exports__